import React, { Component, PropTypes } from 'react';
import styled from 'styled-components';
import { Card, CardTitle, CardHeader, CardText } from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import { Table, TableHeader, TableHeaderColumn, TableRow, TableBody, TableRowColumn } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import orderBy from 'lodash/orderBy';
import { database } from '../../utils/configureFirebase';
import InvalidDrive from '../InvalidDrive';
import months from '../../utils/months';
import csvConverter from '../../utils/csvConverter';

const ContentContainer = styled.div`
  padding: 0 16px;

  & > * + * {
    margin-top: 32px;
  }
`;

const LoaderWrapper = styled.div`
  text-align: center;
`;

const InfoRow = styled.div`
  display: flex;

  & > div {
    width: 33%;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const TableWrapper = styled.div`
  height: 600px;
  width: auto;
  overflow-x: scroll;
`;

const formatDate = date =>
  `${date.date} ${months[date.month].name}, ${date.year}`;

class DriveDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      driveInfo: undefined,
      registrations: undefined,
    };

    this.databaseRef = undefined;
    this.registrationRef = undefined;
  }

  componentDidMount() {
    const { driveId } = this.props;

    this.databaseRef = database.ref(`drives/${driveId}`);
    this.databaseRef.on('value', this.setDriveData);

    this.registrationRef = database.ref(`registrations/${driveId}`);
    this.registrationRef.on('value', this.setRegistrationData);
  }

  componentWillUnmount() {
    this.databaseRef.off('value', this.setDriveData);
    this.registrationRef.off('value', this.setRegistrationData);
  }

  setDriveData = (snapshot) => {
    if (snapshot) {
      const driveInfo = snapshot.val();
      this.setState({
        driveInfo,
      });
    }
  }

  setRegistrationData = (snapshot) => {
    if (snapshot) {
      const registrations = snapshot.val();
      this.setState({
        registrations,
      });
    }
  }

  getRegistrations = (registrations) => {
    if (typeof registrations !== 'undefined') {
      const studentsArr = Object.keys(registrations)
        .map((id) => {
          const formattedData = this.formatRegistration(registrations[id]);
          return {
            ...formattedData,
            id,
          };
        });
      return orderBy(studentsArr, student => student.timestamp, 'asc');
    }

    return [];
  }

  formatRegistration = data => ({
    ...data,
    dob: formatDate(data.dob),
    certifications: data.certifications === '' ? '-' : data.certifications,
  });

  formattedDate = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}-${date.getHours()}:${date.getMinutes()}`;
  }

  render() {
    const { driveInfo, registrations } = this.state;
    const isLoading = (typeof driveInfo === 'undefined' ||
      typeof registrations === 'undefined');

    if (isLoading) {
      return (
        <ContentContainer>
          <LoaderWrapper>
            <CircularProgress />
          </LoaderWrapper>
        </ContentContainer>
      );
    }

    if (driveInfo && registrations) {
      const {
        companyName,
        jobPosition,
        location,
        date,
        lastRegdDate,
      } = driveInfo;

      const studentRegistrations = this.getRegistrations(registrations);
      return (
        <ContentContainer>
          <Card>
            <CardTitle
              title={companyName}
              subtitle={jobPosition}
            />
            <InfoRow>
              <div>
                <CardHeader
                  title="Location"
                />
                <CardText
                  style={{
                    paddingTop: 0,
                  }}
                >
                  {location.description}
                </CardText>
              </div>
              <div>
                <CardHeader
                  title="Campus Date"
                />
                <CardText
                  style={{
                    paddingTop: 0,
                  }}
                >
                  {formatDate(date)}
                </CardText>
              </div>
              <div>
                <CardHeader
                  title="Last Registration Date"
                />
                <CardText
                  style={{
                    paddingTop: 0,
                  }}
                >
                  {formatDate(lastRegdDate)}
                </CardText>
              </div>
            </InfoRow>
          </Card>

          {studentRegistrations.length > 0 && (
            <ButtonContainer>
              <RaisedButton
                primary label="Download CSV"
                onTouchTap={() => {
                  csvConverter(
                    studentRegistrations,
                    `Registration-${companyName}-${formatDate(date)}`,
                  );
                }}
              />
            </ButtonContainer>
          )}

          <TableWrapper>
            <Table
              selectable
              bodyStyle={{
                overflow: 'visible',
              }}
              multiSelectable
              fixedHeader
            >
              <TableHeader displaySelectAll={false}>
                <TableRow>
                  <TableHeaderColumn style={{ width: '20px', paddingLeft: 0 }}>S.No</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '220px' }}>Name</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>College</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>University</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Roll No</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>Gender</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>Date of Birth</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>10th Marks</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>Year of Passing</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>12th Marks</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>Year of Passing</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>Graduation Agg Marks</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '150px' }}>Year of Passing</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Branch</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Degree</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '120px' }}>Backlogs</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '120px' }}>Placement Status</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '250px' }}>Certifications</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>State</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>City</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Email</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Mobile</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '200px' }}>Date of Registration</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false} style={{ overflow: 'scroll' }} >
                {studentRegistrations.map((student, index) => (
                  <TableRow key={student.id}>
                    <TableRowColumn style={{ width: '20px', paddingLeft: 48 }}>{index + 1}</TableRowColumn>
                    <TableRowColumn style={{ width: '220px' }}>{student.name}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.college}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.university}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.rollNo}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.gender}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.dob}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.marks10Board}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.yop10Board}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.marks12Board}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.yop12Board}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.marksGraduation}</TableRowColumn>
                    <TableRowColumn style={{ width: '150px' }}>{student.yopGraduation}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.stream}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.degree}</TableRowColumn>
                    <TableRowColumn style={{ width: '120px' }}>{student.backlogs}</TableRowColumn>
                    <TableRowColumn style={{ width: '120px' }}>{student.placed}</TableRowColumn>
                    <TableRowColumn style={{ width: '250px' }}>{student.certifications}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.state ? student.state : '-'}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.city ? student.city : '-'}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.email}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{student.contact}</TableRowColumn>
                    <TableRowColumn style={{ width: '200px' }}>{this.formattedDate(student.timestamp)}</TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableWrapper>
        </ContentContainer>
      );
    }

    return (
      <InvalidDrive />
    );
  }
}

DriveDetails.propTypes = {
  driveId: PropTypes.string.isRequired,
};

export default DriveDetails;



// WEBPACK FOOTER //
// ./src/views/DriveDetails/DriveDetails.js